export const deploymentOption = `*[_type == 'deploymentOption'][0]{
  wwwAnalyticsThrottle,
}`;
